import { Grid, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

export const IconContainer = styled(Grid)({
  padding: 5,
});

export const ChevronIconButton = styled(IconButton)({
  padding: 10,
  "&:hover": {
    background: "none",
  },
});
